import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { publicAxios } from '../api';

const initialState = {
  footer: [],
  status: 'idle',
  error: null,
};

export const fetchfooter = createAsyncThunk('footer/fetchfooter', async () => {
  const response = await publicAxios.get('/api/settings');
  return response.data.data.settings;
});

const footerSlice = createSlice({
  name: 'footer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchfooter.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchfooter.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.footer = action.payload;
      })
      .addCase(fetchfooter.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default footerSlice.reducer;